import Component, { mixins } from "vue-class-component";
import MyMixin from "@/mixins/datemixin";
import moment from "moment/moment";

@Component
export default class TicketMixin extends mixins(MyMixin) {
  public vendeur: string = "";
  public caisse: string = "";
  public localisation = "";
  public couverts = 0;
  public total = "";
  public beneficiaire = "";
  public ticket = "";
  public tickets: any = [];
  public recus: any = [];
  public date = "";
  public typeTransaction = "";
  public vendeurRemunere: string = "";
  public site: string = "";
  public responsable: string = "";
  public district: string = "";
  public ecart: string = "";
  public etat: string = "";
  public horodatage: string = "";
  public numOrb: string = "";

  public codeImplant: string = "";
  public TTC: string = "";
  public HT: string = "";
  public TVA: string = "";
  public tauxTVA: string = "";
  public reglement: string = "";
  public article: string = "";
  public qte: string = "";
  public prixUnitaire: string = "";
  public EAN: string = "";
  public PAN: string = "";
  public carte: string = "";
  public currency: string = "";

  public generateHeader() {
    if (this.client === "TOTAL") {
      // console.log("valeur ticket:", this.ticket);
      return this.getTotalTicketHeaders();
    } else {
      const heads = [
        {
          text: this.$t("date"),
          value: "horodatage",
          class: "data-head",
          filter: (f: any) =>
            moment(f)
              .format("DD/MM/YYYY HH:mm")
              .toLowerCase()
              .includes(this.date.toLowerCase()),
        },
        {
          text: this.$t("libCaisse"),
          value: "optionalReference.LIB_CAISSE",
          class: "data-head",
          filter: (f: any) =>
            (f + "").toLowerCase().includes(this.caisse.toLowerCase()),
        },
        {
          text: this.$t("vendeur"),
          value: "optionalReference.LIB_VENDEUR",
          class: "data-head",
          filter: (f: any) =>
            (f + "").toLowerCase().includes(this.vendeur.toLowerCase()),
        },
        {
          text: this.$t("ticket"),
          value: "numDoc",
          class: "data-head",
          filter: (f: any) =>
            (f + "").toLowerCase().includes(this.ticket.toLowerCase()),
        },
        {
          text: this.$t("modeConsoShort"),
          value: "optionalReference.LOCALISATION",
          class: "data-head",
          filter: (f: any) =>
            (f + "").toLowerCase().includes(this.localisation.toLowerCase()),
        },
      ];
      if (this.tickets.length > 0) {
        const ticket = this.tickets[0];
        // console.log(ticket);
        if (ticket.optionalReference.MONTANT !== undefined) {
          // console.log("MONTANT", ticket.optionalReference.MONTANT);
          heads.push({
            text: this.$t("total"),
            value: "optionalReference.MONTANT",
            class: "data-head",
            filter: (f: any) =>
              (f + "").toLowerCase().includes(this.total.toLowerCase()),
          });
        }
        if (ticket.optionalReference.LIB_BENEFICIAIRE !== undefined) {
          // console.log("la");
          heads.push({
            value: "optionalReference.LIB_BENEFICIAIRE",
            text: this.$t("beneficiaire"),
            class: "data-head",
            filter: (f: any) =>
              (f + "").toLowerCase().includes(this.beneficiaire.toLowerCase()),
          });
        }
        if (
          ticket.optionalReference.COMPLEMENTS !== undefined &&
          this.client === "BUFFALO"
        ) {
          const libV = ticket.optionalReference.COMPLEMENTS.find(
            (elem: any) => elem.cle === "nomVendeurRemunere"
          );
          if (libV) {
            heads.push({
              value: "optionalReference.COMPLEMENTS",
              text: this.$t("VENDEUR_REMUNERE"),
              class: "data-head",
              filter: (f: any) => {
                const beneficiaire = f.find(
                  (elem: any) => elem.cle === "nomVendeurRemunere"
                );
                return beneficiaire
                  ? beneficiaire.valeur
                      .toLowerCase()
                      .includes(this.vendeurRemunere.toLowerCase())
                    ? ticket
                    : null
                  : ticket;
              },
            });
          }
        } else if (
          ticket.optionalReference.COMPLEMENTS !== undefined &&
          this.client === "BK"
        ) {
          // console.log("la");
          const libV = ticket.optionalReference.COMPLEMENTS.find(
            (elem: any) => elem.cle === "NUM_ORB"
          );
          if (libV) {
            heads.push({
              value: "optionalReference.COMPLEMENTS",
              text: this.$t("ORB"),
              class: "data-head",
              filter: (f: any) => {
                if (f === undefined) {
                  return ticket;
                }
                const beneficiaire = f.find(
                  (elem: any) => elem.cle === "NUM_ORB"
                );
                return beneficiaire
                  ? beneficiaire.valeur
                      .toLowerCase()
                      .includes(this.vendeurRemunere.toLowerCase())
                    ? ticket
                    : null
                  : ticket;
              },
            });
          }
        }
      }
      return heads;
    }
  }

  public generateHeaderFeuilleCaisse() {
    const heads = [
      {
        text: this.$t("date"),
        value: "dateFiscale",
        class: "data-head",
        filter: (f: any) =>
          moment(f)
            .format("DD/MM/YYYY")
            .toLowerCase()
            .includes(this.date.toLowerCase()),
      },
      {
        text: this.$t("Site"),
        value: "libSite",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.site.toLowerCase()),
      },
      {
        text: this.$t("Responsable"),
        value: "validationResponsable",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.responsable.toLowerCase()),
      },
      /*{
                text: this.$t("DM"),
                value: "district",
                class: "data-head",
                filter: (f: any) =>
                  (f + "").toLowerCase().includes(this.district.toLowerCase()),
              },*/
      {
        text: this.$t("Ecart"),
        value: "diff",
        class: "data-head",
        filter: (f: any) => {
          let ecartNum = parseFloat(this.ecart);
          ecartNum = Math.abs(ecartNum);
          // console.log(f, ecartNum, typeof parseFloat(this.ecart));
          if (this.ecart === "" || ecartNum.toString() === "NaN") {
            return true;
          } else {
            return Math.abs(f) >= ecartNum;
          }
        },
      },
      {
        text: this.$t("Etat"),
        value: "etat",
        class: "data-head",
        filter: (f: any) => {
          const etats = this.etat.split(",");
          let exist = false;
          for (const et of etats) {
            // console.log(et);
            if ((f + "").toLowerCase().includes(et.toLowerCase())) {
              exist = true;
            }
          }
          // console.log(etats, exist);
          return exist;
          // console.log(f, this.etat);
          // return (f + "").toLowerCase().includes(this.etat.toLowerCase())},
        },
      },
      {
        text: this.$t("Validation"),
        value: "lastHorodatage",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.horodatage.toLowerCase()),
      },
    ];
    return heads;
  }

  public getTotalTicketHeaders(): any {
    return [
      {
        text: this.$t("CodeImplant"),
        value: "optionalReference.CODE_IMPLANT",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.codeImplant.toLowerCase()),
      },
      {
        text: this.$t("date"),
        value: "horodatage",
        class: "data-head",
        filter: (f: any) =>
          moment(f)
            .format("DD/MM/YYYY HH:mm")
            .toLowerCase()
            .includes(this.date.toLowerCase()),
      },
      {
        text: this.$t("Site"),
        value: "libSite",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.site.toLowerCase()),
      },
      {
        text: this.$t("Caisse"),
        value: "optionalReference.LIB_CAISSE",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.caisse.toLowerCase()),
      },
      {
        text: this.$t("ticket"),
        value: "numDoc",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.ticket.toLowerCase()),
      },
      {
        text: this.$t("TTC"),
        value: "optionalReference.MONTANT_TOTAL",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.TTC.toLowerCase()),
      },
      {
        text: this.$t("HT"),
        value: "optionalReference.HT",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.HT.toLowerCase()),
      },
      {
        text: this.$t("Montant") + " " + this.$t("TVA"),
        value: "optionalReference.MONTANT_TVA",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.TVA.toLowerCase()),
      },
      {
        text: this.$t("TauxTVA"),
        value: "optionalReference.TAUX_TVA",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.tauxTVA.toLowerCase()),
      },
      {
        text: this.$t("typeTransaction"),
        value: "optionalReference.TYPE_TRANSACTION",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.typeTransaction.toLowerCase()),
      },
      {
        text: this.$t("LIBELLE_REGLEMENT"),
        value: "optionalReference.REGLEMENT",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.reglement.toLowerCase()),
      },
      {
        text: this.$t("ARTICLE"),
        value: "optionalReference.LIBELLE_ARTICLE",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.article.toLowerCase()),
      },
      {
        text: this.$t("Quantite"),
        value: "optionalReference.NB_ARTICLES",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.qte.toLowerCase()),
      },
      {
        text: this.$t("PrixUnitaire"),
        value: "optionalReference.PUTTC",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.prixUnitaire.toLowerCase()),
      },
      {
        text: "EAN",
        value: "optionalReference.CODE_EAN",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.EAN.toLowerCase()),
      },
      {
        text: "PAN",
        value: "optionalReference.PAN",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.PAN.toLowerCase()),
      },
      {
        text: this.$t("Carte"),
        value: "optionalReference.FAMILLE_REGLEMENT",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.carte.toLowerCase()),
      },
      {
        text: this.$t("Currency"),
        value: "optionalReference.CURRENCY",
        class: "data-head",
        filter: (f: any) =>
          (f + "").toLowerCase().includes(this.currency.toLowerCase()),
      },
    ];
  }

  public getCsvTickets(typeDoc: string) {
    let recusJson = new Array();
    recusJson = this.tickets.map((recu: any) => {
      return this.transformTicket(recu, typeDoc);
    });
    return recusJson;
  }

  /**
   * methode de mise en forme du beneficiaire pour affichage sur csv
   * @param complements - les liste de complements à analyser pour trouver le bon champ
   * @returns le champ voulu sous forme de string si il existe
   */
  public formatLibBeneficiaire(complements: any) {
    // console.log("hop");
    // console.log(complements);
    let cle = "";
    if (this.client === "BK") {
      cle = "NUM_ORB";
    } else if (this.client === "BUFFALO") {
      cle = "nomVendeurRemunere";
    }
    if (complements === undefined) {
      return "";
    }
    const libV = complements.find((elem: any) => elem.cle === cle);
    return libV ? libV.valeur : "";
  }

  public formatComplements(complements: any, key: string) {
    const libV = complements.find((elem: any) => elem.cle === key);
    return libV ? libV.valeur : "";
  }

  protected transformTicket(recu: any, typeDoc: string) {
    let obj: { [k: string]: any } = {};
    if (this.client !== "TOTAL") {
      obj = {
        dateFiscale: this.formatDateTicket(recu.dateFiscale),
        date: this.formatDateTicketHour(recu.horodatage),
        caisse: recu.optionalReference.LIB_CAISSE,
        numTicket: recu.numDoc,
        numVendeur: recu.optionalReference.NUM_VENDEUR,
        nomVendeur: recu.optionalReference.LIB_VENDEUR,
        localisation: recu.optionalReference.LOCALISATION,
        profit: recu.optionalReference.PROFIT,
        restaurantId: recu.restaurantId,
        site: recu.libSite,
        id: recu.id,
        typeDocument: recu.document,
      };
    } else {
      const tvaTrad = " " + this.$t("TVA");
      obj[this.$t("CodeImplant").toString()] = recu.optionalReference.CODE_IMPLANT;
      obj[this.$t("date").toString()] = this.formatDateTicketHour(recu.horodatage);
      obj[this.$t("Site").toString()] = recu.libSite;
      obj[this.$t("Caisse").toString()] = recu.optionalReference.LIB_CAISSE;
      obj[this.$t("ticket").toString()] = recu.numDoc;
      obj[this.$t("TTC").toString()] = this.formatMoneyForCSV(recu.optionalReference.MONTANT_TOTAL);
      obj[this.$t("HT").toString()] = this.formatMoneyForCSV(recu.optionalReference.HT);
      obj[this.$t("Montant").toString() + tvaTrad] = this.formatMoneyForCSV(recu.optionalReference.MONTANT_TVA);
      obj[this.$t("Taux").toString() + tvaTrad] = recu.optionalReference.TAUX_TVA;
      obj[this.$t("typeTransaction").toString()] = recu.optionalReference.TYPE_TRANSACTION;
      obj[this.$t("LIBELLE_REGLEMENT").toString()] = recu.optionalReference.REGLEMENT;
      obj[this.$t("ARTICLE").toString()] = recu.optionalReference.LIBELLE_ARTICLE;
      obj[this.$t("Quantite").toString()] = recu.optionalReference.NB_ARTICLES;
      obj[this.$t("PrixUnitaire").toString()] = this.formatMoneyForCSV(recu.optionalReference.PUTTC);
      obj["EAN"] = recu.optionalReference.CODE_EAN;
      obj["PAN"] = recu.optionalReference.PAN;
      obj[this.$t("Carte").toString()] =
        recu.optionalReference.FAMILLE_REGLEMENT;
      obj[this.$t("Currency").toString()] = recu.optionalReference.CURRENCY;
    }
    // console.log(recu.optionalReference.MONTANT);
    if (
      recu.optionalReference.MONTANT !== undefined &&
      this.client !== "TOTAL"
    ) {
      obj.total = this.formatNumber(recu.optionalReference.MONTANT);
    }
    if (recu.optionalReference.LIB_BENEFICIAIRE) {
      obj.beneficiaire = recu.optionalReference.LIB_BENEFICIAIRE;
      obj.codeBeneficiaire = recu.optionalReference.CODE_BENEFICIAIRE;
    }
    if (
      this.client === "BUFFALO" &&
      recu.optionalReference.COMPLEMENTS !== undefined
    ) {
      obj.vendeurRemunere = this.formatLibBeneficiaire(
        recu.optionalReference.COMPLEMENTS
      );
      obj.matriculeVendeurRemunere = this.formatComplements(
        recu.optionalReference.COMPLEMENTS,
        "matriculeVendeurRemunere"
      );
      obj.codeVendeurRemunere = this.formatComplements(
        recu.optionalReference.COMPLEMENTS,
        "codeVendeurRemunere"
      );
      obj.idSalarieRemunere = this.formatComplements(
        recu.optionalReference.COMPLEMENTS,
        "idSalarieRemunere"
      );
    }
    if (
      recu.optionalReference.COMPLEMENTS !== undefined &&
      this.client !== "TOTAL"
    ) {
      obj.table = this.formatComplements(
        recu.optionalReference.COMPLEMENTS,
        "TABLE"
      );
      obj.salle = this.formatComplements(
        recu.optionalReference.COMPLEMENTS,
        "SALLE"
      );
      obj.service = this.formatComplements(
        recu.optionalReference.COMPLEMENTS,
        "service"
      );
      obj.couverts = recu.optionalReference.COUVERTS;
    }
    return obj;
  }

  /**
   * Convertis les valeurs d'argent en format CSV pour Excel (donc pas de point mais virgule)
   * @param value
   * @private
   */
  private formatMoneyForCSV(value: number | string | undefined): string {
    if (value === undefined || value === null) { return ""; }

    // Ajouter un caractère non numérique au début pour forcer Excel à traiter comme texte
    const formattedValue = typeof value === "number" ?
      value.toFixed(2).replace(".", ",") :
      String(value).replace(".", ",");

    return formattedValue;  // Pas besoin de forcer Excel si la valeur est déjà entre guillemet dans le CSV
  }

  private formatNumber(num: number) {
    const n = num.toFixed(2);
    return n;
  }

  get client(): string {
    return this.$store.getters["getClient"];
  }
}
